import React from "react";
import { FormattedNumber } from "react-intl";

type PriceProps = {
  currency: string;
  valueInCents?: number;
  value?: number;
};

export default function Price({ currency, valueInCents, value }: PriceProps) {
  if (
    value == null &&
    ((!valueInCents && valueInCents !== 0) || typeof valueInCents !== "number")
  ) {
    return null;
  }
  return (
    <FormattedNumber
      style="currency"
      currency={currency}
      maximumFractionDigits={2}
      value={value != null ? value : valueInCents! / 100}
    >
      {(val) => <strong>{val}</strong>}
    </FormattedNumber>
  );
}
